// Renders pipeline cards in a fixed order, regardless of which ones have
// state attached yet (others render in idle/skipped state).

import { AiPipelineCard } from "./AiPipelineCard";
import { MetaPipelineCard } from "./MetaPipelineCard";
import { OcrPipelineCard } from "./OcrPipelineCard";
import { ReverseImageCard } from "./ReverseImageCard";
import { useStore } from "../state/store";
import type { PipelineId } from "../types/contract";

const ORDER: PipelineId[] = [
  "reverse_image",
  "ocr",
  "meta",
  "ai_gemini",
  "ai_claude",
  "ai_gpt",
  // Future plans: deep_mode, minimap.
];

const AI_PIPELINES = new Set<PipelineId>(["ai_gemini", "ai_claude", "ai_gpt"]);

export function PipelineStack() {
  const cards = useStore((s) => s.pipelineCards);
  const disabled = useStore((s) => s.disabledPipelines);
  return (
    <div className="flex flex-col gap-2 px-3 py-2">
      {ORDER.map((id) => {
        // Hide cards for pipelines the user has disabled. The
        // dispatch path skips disabled slots entirely (no API call,
        // no pipeline events emitted), so a disabled card would
        // sit at "idle" forever — confusing UX. Hide instead.
        if (disabled.includes(id)) {
          return null;
        }
        const state = cards[id] ?? { status: "idle" as const };
        if (id === "reverse_image") {
          return <ReverseImageCard key={id} state={state} />;
        }
        if (id === "ocr") {
          return <OcrPipelineCard key={id} state={state} />;
        }
        if (id === "meta") {
          return <MetaPipelineCard key={id} state={state} />;
        }
        if (AI_PIPELINES.has(id)) {
          return <AiPipelineCard key={id} pipeline={id} state={state} />;
        }
        return null;
      })}
    </div>
  );
}
